// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"92ce4771","455":"fcae2e94","488":"de21c2f1","619":"3dbb5dfe","762":"1f90e124","977":"8c75ba61"}[chunkId] + ".chunk.js";
};